import { render, staticRenderFns } from "./PersonalMaterial.vue?vue&type=template&id=00aa091b&scoped=true"
import script from "./PersonalMaterial.vue?vue&type=script&lang=js"
export * from "./PersonalMaterial.vue?vue&type=script&lang=js"
import style0 from "./PersonalMaterial.vue?vue&type=style&index=0&id=00aa091b&prod&scoped=true&lang=scss"
import style1 from "./PersonalMaterial.vue?vue&type=style&index=1&id=00aa091b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aa091b",
  null
  
)

export default component.exports